import { PageId } from 'constants/pages'

export const enum PageIdStylioCapsule81 {
  SUBSCRIPTIONS_CAPSULE_81 = PageId.SUBSCRIPTIONS_CAPSULE_81,
  SUB_UPSELL_CAPSULE_81 = PageId.SUB_UPSELL_CAPSULE_81,
  FACE_STYLING_PDF_UPSELL_CAPSULE_81 = PageId.FACE_STYLING_PDF_UPSELL_CAPSULE_81,
  PROPORTIONS_PDF_UPSELL_CAPSULE_81 = PageId.PROPORTIONS_PDF_UPSELL_CAPSULE_81,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_CAPSULE_81 = PageId.DOWNLOAD_CAPSULE_81,
}
